<template>
    <div id="app">
        <div class="content">
            <HeaderComponent />
            <div class="container pt-5 content-inside">
                <router-view />
                <loading v-if="loading"/>
                <loading v-if="forceLoading" style="background-color: rgb(255, 255, 255);"/>
            </div>
        </div>
        <FooterComponent class="footer"/>
    </div>
</template>

<script>
import HeaderComponent from './components/shared/Header.vue';
import FooterComponent from './components/shared/Footer.vue';

export default {
    data() {
        return {
            loading: this.$store.getters.loading,
            forceLoading: true
        }
    },
    components: {
      HeaderComponent,
      FooterComponent
    },
    created(){
        this.$store.dispatch('LOGIN_USER');
        this.$store.dispatch('LOCALES');
        this.$store.dispatch('NOTIFICATIONS_COUNT');
        this.$store.dispatch('ASSESSMENT_COUNT');
        this.$store.dispatch('SEPA_MISSING_INFO');

        this.$store.watch( () => {
                return this.$store.getters.locales; // could also put a Getter here
            }, (locales) =>{
                this.$i18n.setLocaleMessage('de',locales);
                this.forceLoading = false;
            }
        );

        this.$store.watch(() => {
            return this.$store.getters.loading;
        }, loading => {
            this.loading = loading;
        });
    }
}
</script>

<style>

</style>
